import { useState } from 'react';

const FIRMALAR = ['postaguvercini.com', 'Netgsm', 'Twilio', 'İleti Merkezi', 'Vodafone SMS', 'Türk Telekom SMS'];

const INP = 'w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-blue-400 bg-white';

export default function SmsAyarlari() {
  var [firma, setFirma]         = useState('postaguvercini.com');
  var [kullanici, setKullanici] = useState('');
  var [sifre, setSifre]         = useState('');
  var [yeniRezChk, setYeniRez]  = useState(true);
  var [yeniRezEk, setYeniRezEk] = useState('');
  var [iptalChk, setIptalChk]   = useState(true);
  var [iptalEk, setIptalEk]     = useState('');

  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold text-gray-800 mb-4">Sms ayarları</h1>

      {/* Uyarı bandı */}
      <div className="bg-blue-50 border border-blue-200 text-blue-700 text-sm rounded-lg px-4 py-3 mb-6 flex items-center gap-2">
        <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd"/>
        </svg>
        Sms paketiniz mevcut değildir.
      </div>

      <div className="flex gap-6 items-start">

        {/* Sol — Firma bilgileri */}
        <div className="w-80 flex-shrink-0">
          <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
            <div className="bg-gray-50 border-b border-gray-200 px-5 py-3 flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
              </svg>
              <span className="text-sm font-semibold text-gray-700">Sağlayıcı Bilgileri</span>
            </div>

            <div className="p-5 flex flex-col gap-4">
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1 uppercase tracking-wide">Firma</label>
                <div className="relative">
                  <select value={firma} onChange={function(e){setFirma(e.target.value);}} className={INP + ' appearance-none pr-8'}>
                    {FIRMALAR.map(function(f){return <option key={f}>{f}</option>;})}
                  </select>
                  <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 text-xs">▼</span>
                </div>
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1 uppercase tracking-wide">Kullanıcı Adı</label>
                <input type="text" value={kullanici} onChange={function(e){setKullanici(e.target.value);}} placeholder="kullanici@ornek.com" className={INP}/>
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1 uppercase tracking-wide">Şifre</label>
                <input type="password" value={sifre} onChange={function(e){setSifre(e.target.value);}} placeholder="••••••••" className={INP}/>
              </div>

              <button className="w-full border border-blue-500 text-blue-600 hover:bg-blue-50 text-sm font-medium py-2 rounded-lg transition-colors">
                🔗 Bağlantıyı Test Et
              </button>
            </div>
          </div>

          <div className="mt-4 bg-amber-50 border border-amber-200 rounded-xl p-4">
            <p className="text-xs font-semibold text-amber-700 mb-1">💡 Nasıl çalışır?</p>
            <p className="text-xs text-amber-600 leading-relaxed">
              Seçtiğiniz SMS sağlayıcısındaki hesap bilgilerinizi girin. Rezervasyon işlemlerinde otomatik SMS gönderimi aktif hale gelir.
            </p>
          </div>
        </div>

        {/* Sağ — Otomatik SMS ayarları */}
        <div className="flex-1 flex flex-col gap-4">

          <div className="flex items-center gap-2 mb-1">
            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
            </svg>
            <span className="text-sm font-semibold text-gray-700">Otomatik SMS Tetikleyicileri</span>
          </div>

          {/* Yeni rezervasyon bloğu */}
          <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
            <label className="flex items-center gap-3 px-5 py-4 cursor-pointer select-none hover:bg-gray-50 transition-colors">
              <input type="checkbox" checked={yeniRezChk} onChange={function(e){setYeniRez(e.target.checked);}} className="w-4 h-4 accent-blue-600"/>
              <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-green-100">
                <svg className="w-3.5 h-3.5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4"/>
                </svg>
              </span>
              <span className="text-sm font-semibold text-gray-800">Yeni rezervasyon eklendiğinde SMS gönder</span>
              <span className={'ml-auto text-xs font-medium px-2 py-0.5 rounded-full ' + (yeniRezChk ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500')}>
                {yeniRezChk ? 'Aktif' : 'Pasif'}
              </span>
            </label>

            {yeniRezChk && (
              <div className="px-5 pb-5 border-t border-gray-100">
                <div className="mt-4 bg-gray-50 border border-gray-200 rounded-lg p-3 mb-4">
                  <p className="text-xs font-semibold text-gray-500 mb-1">Örnek gönderilecek mesaj:</p>
                  <p className="text-xs text-gray-700 leading-relaxed">
                    Sn. Hasan tuncer 01.01.2023 tarihli rezervasyonunuz yapılmıştır. Giriş:01.01.2023 11:00 - Çıkış:02.01.2003 14:00 tarihindedir.
                    <span className="text-blue-500"> [Ek mesajınız]</span>
                  </p>
                </div>
                <label className="block text-xs font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                  Ekleme mesaj formatı <span className="font-normal normal-case text-gray-400">(Sms altında yer alacaktır)</span>
                </label>
                <textarea value={yeniRezEk} onChange={function(e){setYeniRezEk(e.target.value);}} placeholder="Sms altı ekleme mesaj" rows={3} className={INP + ' resize-none'}/>
              </div>
            )}
          </div>

          {/* İptal bloğu */}
          <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
            <label className="flex items-center gap-3 px-5 py-4 cursor-pointer select-none hover:bg-gray-50 transition-colors">
              <input type="checkbox" checked={iptalChk} onChange={function(e){setIptalChk(e.target.checked);}} className="w-4 h-4 accent-blue-600"/>
              <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-red-100">
                <svg className="w-3.5 h-3.5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12"/>
                </svg>
              </span>
              <span className="text-sm font-semibold text-gray-800">Rezervasyon iptalinde SMS gönder</span>
              <span className={'ml-auto text-xs font-medium px-2 py-0.5 rounded-full ' + (iptalChk ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500')}>
                {iptalChk ? 'Aktif' : 'Pasif'}
              </span>
            </label>

            {iptalChk && (
              <div className="px-5 pb-5 border-t border-gray-100">
                <div className="mt-4 bg-gray-50 border border-gray-200 rounded-lg p-3 mb-4">
                  <p className="text-xs font-semibold text-gray-500 mb-1">Örnek gönderilecek mesaj:</p>
                  <p className="text-xs text-gray-700 leading-relaxed">
                    Sn. Hasan tuncer 01.01.2023 giriş tarihli rezervasyonunuz sizin isteğiniz doğrultusunda iptal edilmiştir.
                    <span className="text-blue-500"> [Ek mesajınız]</span>
                  </p>
                </div>
                <label className="block text-xs font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                  İptal mesaj formatı <span className="font-normal normal-case text-gray-400">(Sms altında yer alacaktır)</span>
                </label>
                <textarea value={iptalEk} onChange={function(e){setIptalEk(e.target.value);}} placeholder="sms altı iptal mesaj" rows={3} className={INP + ' resize-none'}/>
              </div>
            )}
          </div>

        </div>
      </div>

      {/* Kaydet */}
      <div className="mt-6">
        <button onClick={function(){alert('Ayarlar kaydedildi.');}} className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-8 py-2.5 rounded-lg shadow-sm transition-colors">
          Kaydet
        </button>
      </div>
    </div>
  );
}